import { useEffect } from 'react';
import { useViewerCountry } from '../lib/geo';
import { runSfCookieSync } from '../lib/consent';

/**
 * Runs runSfCookieSync() once the viewer country resolves. Catches the
 * first-time-visitor case that the synchronous initConsent() boot path
 * misses: on a fresh session there's no cached country in sessionStorage
 * yet, so initConsent's synchronous SF sync skips. Once useViewerCountry's
 * /geo round-trip lands, this effect picks up and applies the SF Analytics
 * signal (if the cookie says denied).
 *
 * Renders nothing. Mount once at app level next to ConsentBanner so we
 * share the (already-cached, deduplicated) useViewerCountry call.
 *
 * Idempotent: runSfCookieSync bails on any higher-priority signal
 * (existing gh_consent record from GPC or user toggle), so re-running
 * this after initConsent already ran the synchronous path is a clean
 * no-op.
 */
export default function SfCookieSync() {
  const { country, loading } = useViewerCountry();
  useEffect(() => {
    if (loading) return;
    runSfCookieSync(country);
  }, [country, loading]);
  return null;
}
